import script from "./modelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./modelDialog.vue?vue&type=script&setup=true&lang=js"

import "./modelDialog.vue?vue&type=style&index=0&id=064c4172&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\learning-center\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064c4172"]])

export default __exports__